export const CASE_SENSITIVE = "case-sensitive";
export const EXPANDABLE_ROWS = "expandable-rows";
export const FILTER_LOGIC = "filter-logic";
export const HIGHLIGHT_FILTERS = "highlight-filters";
export const PRETTY_PRINT_BOOKMARKS = "pretty-print-bookmarks";
export const WRAP = "wrap";
export const WRAP_FORMAT = "wrap-format";
export const ZEBRA_STRIPING = "zebra-striping";
export const STICKY_HEADERS = "sticky-headers";

export const DRAWER_OPENED = "drawer-opened";
export const HAS_SEEN_SEARCHBAR_GUIDE_CUE =
  "has-seen-searchbar-guide-cue-tab-complete";

export const LAST_SELECTED_LOG_TYPE = "last-selected-log-type";

export const COPY_FORMAT = "default-copy-format";

export const EXCLUDE_TIMESTAMPS = "exclude-timestamps";

export const JUMP_TO_FAILING_LINE_ENABLED = "jump-to-failing-line-enabled";
export const SECTIONS_ENABLED = "sections-enabled";
